import React from 'react';
import {marked} from 'marked';
import uiTexts from 'data/ui-texts';

/**
 * Parse markdown text
 * @param {string} marked
 * @return {html}
 */
const renderMarkdown = (markdown) => {
	if (markdown && typeof markdown === 'string' && markdown.length > 0) {
		let lexed = marked.lexer(markdown);
		let parsed = marked.parser(lexed);
		return <div dangerouslySetInnerHTML={{__html: parsed}} />;
	}
	return <div />;
};


/**
 * Get text
 * @param {string} text 
 * @param {string} languageId 
 * @param {array} replacements
 * @returns 
 */
const getText = (text, languageId) => {
	let uiText = '';

	if (!languageId) {
		console.error(text);
		console.error('missing language id');
	}
	/* Get ui text for language */
	if (typeof text === 'object') {
		/* Text is object */
		if (text && text.hasOwnProperty(languageId)) {
			uiText = text[languageId];
		}
	} else if (typeof text === 'string') {
		/* Text is string */
		if (text && text.length > 0) {
			const textIdArray = text.split('_');
			if (textIdArray.length > 1) {
				let textObj = uiTexts;
				textIdArray.forEach((property) => {
					if (textObj.hasOwnProperty(property)) {
						textObj = textObj[property];
					} else {
						console.error(text, property);
					}
				});
				if (textObj.hasOwnProperty(languageId)) {
					uiText = textObj[languageId];
				}
			} else {
				uiText = text;
			}
		}
	}

	return uiText;
};


export {
	getText,
	renderMarkdown
};